export const coreAddresses = {
  balanceTracker: "0xbCD29c1B596d9fFAfaa6F90780956b4D3d47832f",
  eVaultFactory: "0x78Df1CF5bf06a7f27f2ACc580B934238C1b80D50",
  eVaultImplementation: "0x832fF4011A3164ea76ceA06A313EE0B6CD72ba96",
  eulerEarnFactory: "0xB9B5d62B9fE9E1B505466e75817aB178A1D2ec9d",
  evc: "0x6302ef0F34100CDDFb5489fbcB6eE1AA95CD1066",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x06c1Ab0A1672E8FC7F7D10BD7B869B4116D18a2c",
  sequenceRegistry: "0x924C73abAa350800fc22c11ffdFB09641106E3ce",
} as const
